export default {
  title: 'Contacts',

  copyTo: 'Copy to',

  titles: {
    custom: {
      fields: 'Custom fields'
    }
  },

  labels: {
    list: 'List',
    phone: 'Phone',
    email: 'E-mail',
    firstName: 'First name',
    lastName: 'Last name',
    middleName: 'Middle name',
    date: 'Date of birth',
    gender: 'Gender',
    contactList: 'Contact list',
    actions: '',
    custom: 'Custom field',
    custom01: 'Custom 01',
    custom02: 'Custom 02',
    custom03: 'Custom 03',
    custom04: 'Custom 04',
    custom05: 'Custom 05',
    custom06: 'Custom 06',
    custom07: 'Custom 07',
    custom08: 'Custom 08',
    custom09: 'Custom 09',
    custom10: 'Custom 10',
    custom11: 'Custom 11',
    custom12: 'Custom 12',
    custom13: 'Custom 13',
    custom14: 'Custom 14',
    custom15: 'Custom 15',
    custom16: 'Custom 16',
    custom17: 'Custom 17',
    custom18: 'Custom 18',
    custom19: 'Custom 19',
    custom20: 'Custom 20',
    clear: 'Clear filter',
    name: 'Name'
  },

  dialogs: {
    titles: {
      create: 'Create contact',
      update: 'Update contact',
      remove: 'Remove contact',
      import: 'Import contacts'
    }
  },

  subheaders: {
    custom: 'Custom fields',
    date: 'Select date of birth'
  },

  emptyState: {
    emptyAddressBook: 'No address books found',
    title: 'No contacts',
    description: '{0} a csv/xls/xlsx file or {1} a single contact'
  },

  contents: {
    confirm: {
      remove: 'Are you sure you want to delete the contact?'
    },
    import: {
      loading: 'The dialog will close automatically when the import is complete.',
      success: 'Successfully imported: {count}.',
      error: 'Unfortunately, we could not import a single number from the uploaded file.<br><ul><li>Check whether the column names in the file are correct. Try renaming the phone number column to "phone".</li><li>If you cannot upload a CSV file, try XLSX or XLS. In this case, the records must be on the first sheet / workbook.</li><li>Contact support for help. We may need your file to investigate the issue.</li></ul>'
    }
  },

  buttons: {
    add: 'Add',
    remove: 'Remove'
  },

  tooltips: {
    add: 'Add one contact to the contact list',
    remove: 'Delete a contact from the contact list',
    loading: 'Loading...',
    total: '&#xB7&#xB7&#xB7\nTotal {total}',
    noData: 'No contacts',
    permanent: 'Insert the word "permanent" into this field'
  },

  errors: {
    phone: 'Invalid phone number format',
    email: 'Invalid e-mail format',
    phoneOrEmail: 'Enter a phone number or e-mail',
    fio: 'Only letters, spaces, hyphens, and apostrophes are allowed'
  },

  snackbars: {
    created: 'Contact successfully created.',
    updated: 'Contact successfully updated.',
    removed: 'Contact successfully removed.'
  }
}
